export const IATA_FIELD = 'iata';
export const PASSWORD_FIELD = 'password';
export const AGENT_NAME_FIELD = 'agentName';
export const AGENCY_NAME = 'agencyname';
export const AGENCY_ADDRESS = 'agencyaddress';
export const SELECT_COUNTRY = 'agencycountry';
export const SELECT_STATE = 'agencystate';
export const AGENCY_CITY = 'agencycity';
export const PIN_CODE = 'agencypincode';
export const AGENCY_PHONE_NUMBER = 'agencyphonenumber';
export const AGENCY_FAX_NUMBER = 'agencyfaxnumber';
export const AGENCY_EMAIL_ADDRESS = 'agencyemailaddress';
export const AGENCY_CONTACT_NAME = 'agencycontactname';
export const AGENCY_IDENTIFICATION_TYPE = 'agencyidentificationtype';
export const AGENCY_IDENTIFICATION_NUMBER = 'agencyidentificationnumber';
export const CREATE_AGENCY_PASSWORD = 'createagencypassword';
export const AGENCY_CERTIFICATE_UPLOAD = 'agencyCertificateUpload';
export const W_CERTIFICATE_UPLOAD = 'w-9-certificateupload';
export const COMMISION_AGENCY_NAME = 'commisionagencyname';
export const COMMISION_AGENCY_ADDRESS = 'commisionagencyaddress';
export const COMMISION_AGENCY_COUNTRY = 'commisionagencycountry';
export const COMMISION_AGENCY_STATE = 'commisionagencystate';
export const COMMISION_AGENCY_CITY = 'commisionagencycity';
export const COMMISION_AGENCY_PINCODE = 'commisionagencypincode';